import { render, staticRenderFns } from "./ReportForms.vue?vue&type=template&id=6b3bea32&"
import script from "./ReportForms.vue?vue&type=script&lang=js&"
export * from "./ReportForms.vue?vue&type=script&lang=js&"
import style0 from "./ReportForms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports